module.exports = __webpack_public_path__ + "static/media/teeth-header.cd9c60bc.png";